import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../service/api.service';
import { CoreService } from '../../../service/core.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { TranslateService,LangChangeEvent } from '@ngx-translate/core';
import { element } from 'protractor';

@Component({
  selector: 'app-sales-return-settings',
  templateUrl: './sales-return-settings.component.html',
  styleUrls: ['./sales-return-settings.component.css']
})
export class SalesReturnSettingsComponent implements OnInit {
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '150px',
    minHeight: '150px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'http://127.0.0.1:8000/api/saless/upimgs',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
  };



  srs_pay_types = [
    { id: 1, name: 'Default'},
    { id: 2, name: 'Cash' },
    // { id: 3, name: 'Credit' },
    { id: 4, name: 'Bank' },
    
  ];

  duplicate_items = 0;
  cmpny: any;
  settings: any;
  pageLoadingImg =false;
  srs_pay_type =1;
 
  constructor(private apiService: ApiService, private coreService: CoreService,private translate: TranslateService) { }

  ngOnInit() {
    this.cmpny = this.coreService.getUserData('cmpny');
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.langChange();
    });
    // this.searchCat('');
    this.langChange();
    this.getSalesReturnSetting();
  
   
  }

  getSalesReturnSetting() {

    this.apiService.getSalesReturnSetting().subscribe((res) => {
      console.log('res',res);
      
      if (res['data']) {
        this.settings = res['data'];
      
        this.srs_pay_type = this.settings.srs_pay_type;
      
      } else { 
        this.srs_pay_type = 1;
        
      }
    });

  }


  update(formdata: { value: any; }) {
    this.pageLoadingImg = true;

    this.apiService.updateSalesReturnSetting(formdata.value).subscribe((res) => {
      this.pageLoadingImg = false;
      if (res.data) {
        this.coreService.showMessage('Setting Saved');

      }
    }, (error) => {
      this.pageLoadingImg = false;
    });
  }

 

   // search category

  langChange(){
 


  }

}


